import { RootState } from "reducks/rootReducer";

export const selectCacheItem = (state: RootState, hash: string) => {
  return state.cache[hash] || null;
};
